module.exports = __webpack_public_path__ + "static/img/first.383a582.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tstj/first.png
// module id = 8HxM
// module chunks = 1